<template>
  <div>
    <div v-if="filteredDataset.length > 0">
      <table class="table table-striped is-narrow">
        <thead>
          <tr>
            <th>{{$t('facility.inputs.entity')}}</th>
            <th>{{$t('users.roles.role')}}</th>
            <th v-if="editable"></th>
          </tr>
        </thead>
        <tbody>
          <tr style="height:63px" v-for="(item, index) in filteredDataset" :key="index">
            <td width="30%" class="align-middle dataset__label">
              <span class="dataset__label__description">
                {{item.name}} {{item.cities && item.cities.length ? '(' + item.cities.join(', ') + ')' : ''}}&nbsp;
              </span>
            </td>
            <td :width="tdDynamicSize" class="tag__role__item align-middle">
              <div v-if="!isEditingRole || editingRow !== index">
                <div v-if="item.roles.length > 0">
                  <div v-if="item.roles.length > limitItems">
                    <va-popover
                      class="custom-tooltip-tag"
                      v-for="(item, index) in getFirstNItems(item.roles, limitItems)" :key="index"
                      :message="item.description"
                      placement="top">
                      <div class="tag-role">
                        <span>{{item.name}}</span>
                        &nbsp;
                        <i class="cursor-help fa fa-question-circle"></i>
                      </div>
                    </va-popover>
                    <div @click="openAllRoles(item)" class="tag-role tag-role-clicable">
                      {{$t('users.roles.actions.show_more')}} {{item.roles.length - limitItems}}..
                    </div>
                  </div>
                  <div v-else>
                    <va-popover
                      class="custom-tooltip-tag"
                      v-for="(item, index) in item.roles" :key="index"
                      :message="item.description"
                      placement="top">
                    <div class="tag-role">
                      <span>{{item.name}}</span>
                      &nbsp;
                      <i class="role-help-icon cursor-help fa fa-question-circle"></i>
                    </div>
                  </va-popover>
                  </div>
                </div>
                <div v-else>
                  {{ $t('users.roles.without')}}
                </div>
              </div>
              <div v-if="isEditingRole && editingRow === index">
                <div class="form-group" style="margin-bottom:0rem;">
                  <div class="input-group clearable-filter">
                    <multiselect
                      :options="availableRoles"
                      :value="editingRoles"
                      @select="handleSelect"
                      @remove="handleDeselect"
                      track-by="id"
                      label="name"
                      select-label=""
                      deselect-label="×"
                      :placeholder="$t('users.roles.title')"
                      :allow-empty="true"
                      :multiple="true"
                      :searchable="true"
                      :close-on-select="false"
                      :limit="limitItems">
                      <span slot="noResult">{{$t('patients.noResults')}}</span>
                      <template slot="tag" slot-scope="{ option, remove }">
                        <span class="custom__tag" :class="{'without_remove_action': option.$isDisabled}">
                          <span>{{ $t(`roles.${option.id}`, option.name) }}&nbsp;</span>
                          <i v-if="!option.$isDisabled" @click="removeEntity(option, remove)" aria-hidden="true" tabindex="1" class="custom__tag-icon"></i>
                        </span>
                      </template>
                      <template slot="option" slot-scope="{option}">
                        <span>{{ $t(`roles.${option.id}`, option.name) }}&nbsp;</span>
                      </template>
                      <template slot="clear" slot-scope="props">
                        <div class="multiselect__clear" v-if="editingRoles.length" @mousedown.prevent.stop="removeEditableRoles(props)"></div>
                      </template>
                    </multiselect>
                  </div>
                </div>
              </div>
            </td>
            <td v-if="editable" class="align-middle">
              <div class="d-flex justify-content-end">
                <span v-if="!isEditingRole && hasRolesToEdit(item)" @click.prevent="editUserEntityRole(item, index)">
                    <i class="fa fa-pencil clickable"></i>
                </span>
                <va-button
                  v-if="isEditingRole && editingRow === index"
                  class="btn-cancel mr-2"
                  @click.prevent="cancelEdit(item.id, index)">
                  {{ $t('users.roles.actions.cancel') }}
                </va-button>
                <va-button
                  v-if="isEditingRole && editingRow === index"
                  class="mr-2"
                  @click.prevent="saveUserEntityRole(item)">
                  {{ $t('users.roles.actions.save') }}
                </va-button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <div v-if="this.query !== ''" class="d-flex justify-content-center pt-4">
        <b>{{$t('users.roles.no_entities_found')}}</b>
      </div>
      <div v-else class="d-flex justify-content-center pt-4">
        <b> {{$t('users.roles.no_entities')}} </b>
      </div>
    </div>
    <div class="d-flex justify-content-center" v-if="editable && shouldDisplayViewAllOption">
      <a href="#" @click.prevent="toogleViewAll">
        <span v-if="!viewAll">{{$t('users.roles.view_all')}}</span>
        <span v-else>{{$t('users.roles.hide')}}</span>
      </a>
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import DynamicSizeMixin from '../../Helpers/DynamicSizeMixin'
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
import { sortByName, sortByRoles } from './utils/sorters'
export default {
  props: {
    roles: {
      type: Array,
      required: true
    },
    subRoles: {
      type: Array,
      required: false
    },
    query: {
      type: String,
      required: false,
      default: ''
    },
    limitItems: {
      type: Number,
      required: false,
      default: 3
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    Multiselect
  },
  data () {
    return {
      isEditingRole: false,
      editingRow: -1,
      availableRoles: [],
      editingRoles: [],
      dataset: [],
      showFullRoles: false,
      viewAll: false,
    }
  },
  mixins: [
    DynamicSizeMixin,
  ],
  mounted () {
    this.generateDataset()
  },
  methods: {
    toogleViewAll: function () {
      this.viewAll = !this.viewAll
    },
    removeEditableRoles: function () {
      this.editingRoles = this.editingRoles.filter(option => {
        return option.$isDisabled
      })
    },
    hasRoleOrSubroleForEntity: function (entityId, roleId) {
      return this.authUserRoles.filter(item => item.entity_id === entityId || item.entity_id === null)
        .some(ur => {
          return ur.role_id === roleId || this.subRoles.some(role => {
            return role.id === ur.role_id && role.subroles.some(subrole => subrole.id === roleId)
          })
        })
    },
    closeEntitiesByRoleModal: function () {
      this.showFullRoles = false
      this.entitiesForSelectedRole = []
    },
    openAllRoles: function (entity) {
      this.isEditingRole = false
      this.showFullRoles = true
      this.$emit('showRolesForEntityModal', {
        roles: entity.roles,
        entity
      })
    },
    hasRolesToEdit: function (item) {
      return this.availableRolesByEntity(item.id).some(role => !role.$isDisabled)
    },
    removeEntity: function (item, index) {
      this.editingRoles = this.editingRoles.filter(ur => ur.id !== item.id)
    },
    canRemoveOption: function (item, option) {
      return this.availableRolesByEntity(item.id).some(role => role.id === option.id)
    },
    generateDataset: function () {
      this.dataset = []
      this.authEntitiesRolesPermissions.forEach(entity => {
        let index = this.dataset.findIndex(item => item.id === entity.id)
        if (index === -1) {
          this.dataset.push({
            id: entity.id,
            name: entity.name,
            cities: entity.cities,
            roles: [],
            availableRoles: []
          })
        }
      })

      // Para cada entidade do utilizador para qual está a editar
      this.roles.forEach(userRole => {
        // Se utilizador destino tiver uma role a null, é necesário percorrer o dataset e atribuir essa role a todas as entidades que o utilizador logado tem acesso
        if (userRole.entity === null) {
          this.dataset.forEach(item => {
            item.roles.push({
              ...userRole.role,
              $isDisabled: true
            })
          })
          return
        }
        // Se encontrar um indice de entidade para esse utilizador adiciona as roles dessa entidade
        let index = this.dataset.findIndex(item => item.id === userRole.entity.id)
        if (index >= 0) {
          let item = this.dataset[index]
          item.roles.push({
            ...userRole.role,
            $isDisabled: !this.hasRoleOrSubroleForEntity(item.id, userRole.role.id)
          })
        }
      })
      this.dataset.sort(sortByRoles || sortByName)
    },
    handleDeselect: function (item) {
      if (this.availableRoles.some(role => role.id === item.id && !role.$isDisabled)) {
        this.editingRoles = this.editingRoles.filter(role => role.id !== item.id)
      }
    },
    handleSelect: function (item) {
      this.editingRoles.push(item)
    },
    availableRolesByEntity: function (entityId) {
      let uniqueRoles = []
      let subRoles = []
      const datasetItem = this.dataset.find(item => item.id === entityId)
      let validRoles = this.authUserRoles.filter(userRole => this.writeAuthRolesPermissions.some(permission => permission.entity_id === userRole.entity_id))
        .filter((item) => item.entity_id === entityId || item.entity_id === null)
      validRoles = validRoles.concat(subRoles)
      validRoles.filter((item) => {
        return item.entity_id === entityId || item.entity_id === null
      }).forEach(item => {
        let role = this.authRoles.find(role => role.id === item.role_id)
        if (role && !uniqueRoles.some(r => r.id === role.id)) {
          let roleItem = datasetItem.roles.find(data => data.id === role.id && data.$isDisabled)
          if (roleItem) {
            uniqueRoles.push(roleItem)
          } else {
            uniqueRoles.push(role)
          }
        }

        let subroles = this.subRoles.find(role => {
          return role.id === item.role_id
        })
        if (subroles && subroles.subroles.length > 0) {
          uniqueRoles.push(...subroles.subroles)
        }
      })
      // Remove duplicates from array
      return uniqueRoles.filter((item, index) => {
        return index === uniqueRoles.findIndex(obj => {
          return obj.id === item.id
        })
      })
    },
    editUserEntityRole: function (userRole, selectedRow) {
      if (selectedRow !== this.editingRow) {
        this.isEditingRole = true
        this.editingRow = selectedRow
        this.editingRoles = JSON.parse(JSON.stringify(userRole.roles))
        this.availableRoles = this.availableRolesByEntity(userRole.id)
        this.editingRoles.forEach(role => {
          if (!this.availableRoles.some(item => item.id === role.id)) {
            this.availableRoles.push(role)
          }
        })
      } else {
        this.isEditingRole = !this.isEditingRole
        this.editingRow = -1
      }
    },
    getFirstNItems: function (arr, n) {
      return arr.slice(0, n)
    },
    saveUserEntityRole: function (entity) {
      let validRoles = this.editingRoles.filter(role => !role.$isDisabled).map(role => role.id)
      let formObject = {
        entity_id: entity.id,
        roles: validRoles
      }
      this.$emit('updateUserRules', formObject)
      this.resetFields()
    },
    cancelEdit: function () {
      this.editingRow = -1
      this.isEditingRole = false
    },
    resetFields: function () {
      this.editingRow = -1
      this.isEditingRole = false
      this.editingRoles = []
      this.dataset = []
      this.generateDataset()
    }
  },
  computed: {
    ...mapGetters([
      'services'
    ]),
    shouldDisplayViewAllOption: function () {
      let numberEntitiesWithRoles = this.dataset.reduce((accumulator, datasetRow) => {
        if (datasetRow.roles.length) {
          return accumulator + 1
        }
        return accumulator
      }, 0)
      return this.authRolesPermissions.length !== numberEntitiesWithRoles
    },
    filteredDataset: function () {
      let filteredDataset = this.dataset
      if (!this.viewAll && this.query === '') {
        filteredDataset = filteredDataset.filter(datasetItem => datasetItem.roles.length)
      }
      if (this.query !== '') {
        filteredDataset = filteredDataset.filter(item => {
          return item.name.toLowerCase().indexOf(this.query.toLowerCase()) !== -1
        })
      }
      return filteredDataset
    },
    selectedService: function () {
      return this.$store.getters.globalAuthService
    },
    authUserRoles: function () {
      return this.selectedService.user_roles
    },
    authRoles: function () {
      return this.selectedService.roles
    },
    authPermissions: function () {
      return this.selectedService.user_permissions
    },
    authRolesPermissions: function () {
      return this.authPermissions.filter(p => p.info_type === 100)
    },
    writeAuthRolesPermissions: function () {
      return this.authRolesPermissions.filter(p => p.access_type >= 2)
    },
    authEntitiesRolesPermissions: function () {
      return this.authEntities.filter(e => {
        return this.authRolesPermissions.some(p => p.entity_id === e.id || p.entity_id === null)
      })
    },
    authEntities: function () {
      return this.selectedService.entities
    }
  },
  watch: {
    filterByUnlocked: {
      handler (value) {
        this.generateDataset()
      }
    },
    roles: {
      handler () {
        this.generateDataset()
      },
      deep: true
    },
    query: debounce(function () {
      this.generateDataset()
    }, 500)
  }
}
</script>

<style lang="scss">
  .tag-role{
    margin-right: 10px;
    margin-bottom: 0.5rem;
    padding: 0.4em 1em;
    background: #29c4a9;
    color: white;
    border-radius: 1em;
    font-weight: 100;
    font-size: 13px;
  }

  .action-buttons-wrapper{
      margin-top: 10px;
  }

  .btn-action-role{
    padding: 0.6rem 1.45rem !important;
    letter-spacing: 1px !important;
    font-size: 9px !important;
  }

  .custom__tag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    border-radius: 5px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    background: #29c4a9;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  .custom__tag-icon {
    cursor: pointer;
    margin-left: 7px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    font-weight: 700;
    font-style: normal;
    width: 22px;
    text-align: center;
    line-height: 22px;
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
    border-radius: 5px;
  }

  .custom__tag-icon:focus, .custom__tag_removable-icon:hover {
    background: #21ab93;
  }

  .custom__tag-icon:after {
    content: "\D7";
    color: #266d4d;
    font-size: 14px;
  }

  .custom__tag-icon:focus:after, .custom__tag-icon:hover:after {
    color: #fff;
  }

  .without_remove_action{
    padding-right: 10px !important;
  }

  .dataset__label {
    min-width: 30%;
  }

  .dataset__label__description {
    padding-left: 5px;
  }

  .role-help-icon {
    color: white !important;
  }
</style>
